/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Status_UnmatchedInputs */

const vi_reconcile_status_unmatched = /** @type {(inputs: Reconcile_Status_UnmatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa khớp`)
};

/**

* @param {Reconcile_Status_UnmatchedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_status_unmatched = /** @type {((inputs?: Reconcile_Status_UnmatchedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Status_UnmatchedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_status_unmatched(inputs)
});